import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Guard, mappingResultError, Result, UseCase } from '@digibricks/domains';
import { Answer } from '../../../domain';
export var CREATE_ANSWER_USE_CASE = 'CREATE_ANSWER_USE_CASE';
export var CreateAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CreateAnswerUseCase, _UseCase);

  var _super = _createSuper(CreateAnswerUseCase);

  function CreateAnswerUseCase() {
    _classCallCheck(this, CreateAnswerUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(CreateAnswerUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, data, guardCollection, guardResult, description, answerResult, updatedResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, data = input.data;
                guardCollection = [{
                  argument: currentQuestion,
                  argumentName: 'Current Question'
                }, {
                  argument: data,
                  argumentName: 'Data input'
                }];
                guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

                if (guardResult.succeeded) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", new BadInputError(guardResult.message));

              case 5:
                description = data.description;
                answerResult = Answer.create({
                  description: description
                });

                if (!answerResult.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", mappingResultError(answerResult));

              case 9:
                updatedResult = currentQuestion.addNewAnswer(answerResult.getValue());

                if (!updatedResult.isFailure) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", mappingResultError(answerResult));

              case 12:
                return _context.abrupt("return", Result.ok(currentQuestion));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CreateAnswerUseCase;
}(UseCase);